import Button from '@mui/material/Button'

import { AppLinkButton } from './AppLinkButton'

type AppErrorViewProps = {
  actionLabel?: string
  status?: number
  title: string
  description: string
  onAction?: () => void
}

export function AppErrorView({
  actionLabel = 'На главную',
  status,
  title,
  description,
  onAction,
}: AppErrorViewProps) {
  return (
    <main className="error-view">
      {status ? <p className="error-status">{status}</p> : null}
      <h1>{title}</h1>
      <p>{description}</p>
      {onAction ? (
        <Button color="success" onClick={onAction} variant="contained">
          {actionLabel}
        </Button>
      ) : (
        <AppLinkButton to="/">{actionLabel}</AppLinkButton>
      )}
    </main>
  )
}
